import React, { type FC, type PropsWithChildren } from 'react'
import { Typography, type TypographyProps } from '@mui/material'

import { BaseLoader, type BaseLoaderProps } from './Wrapper'

export const TypographyLoader: FC<PropsWithChildren<Pick<TypographyProps, 'variant'> & BaseLoaderProps>> = ({ variant, children, ...props }) => (
    <BaseLoader {...props}>
        <Typography variant={variant}>{children}</Typography>
    </BaseLoader>
)
